
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { ProductCategoryType } from './product-category-type-entity';


export class ProductCategory extends BaseEntity {
  
  productCategoryCode     : string;
  name                    : string;
  rank                    : number;

  productCategoryTypes    : ProductCategoryType[];

  constructor() {
   super()
  }
  
}
